import { obterCondicoesAsync } from "../../services/condicaoPagamentoService";

const atualizarCondicoes = async ({ commit }) => {
    const condicoes = await obterCondicoesAsync();
    commit('atualizarCondicoes', condicoes);
}

const atualizarCondicao = ({ commit }, condicao) => {
    commit('atualizarCondicao', condicao);
}

export default {
    atualizarCondicoes,
    atualizarCondicao
}